module.exports = __webpack_public_path__ + "static/profile-pic-724aae340f0ea5d168765e3521033f35.jpg";